const constants = {
  title: "Sugerencias",
};

export default constants;
